import type { RootState } from "types/redux";

export const getActiveModals = (state: RootState) => state.domains.modal.activeModals;

const getActiveModal = (state: RootState) => {
  // This try-catch shouldn't be necessary and is only included to work around an error that the pingdom bot is encountering.
  try {
    return state.domains.modal.activeModals.at(-1);
  } catch {
    return undefined;
  }
};

export const getActiveModalId = (state: RootState) => getActiveModal(state)?.id;

export const getModalParams = (state: RootState) => getActiveModal(state)?.params ?? empty;

const empty = {};
